import axios from 'axios';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import { fetchHandler } from '../../utils/apiUtils';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchSamples = async ({
  sampleName,
  sampleDescription,
  sampleSource,
  samplingDateFrom,
  samplingDateTo,
  sampleDateCreatedFrom,
  sampleDateCreatedTo,
  sampleStatusName,
  sampleCategory,
  sampleType,

  locationIDs,
  clientIDs,
  sourceSystemIDs,
  divisionIDs,
  sentFromIds,
  sentBy,
  projects,
  jobName,
  sampleNumber,
  page,
  pageSize,
  sortBy,

  bunkeringCountryIds,
  fuelSupplierIds,
  fleetNames,
  vesselNames,
  imoNumbers,
  submissionTypeIds,
  productTypeIds,
  gradeIds,
  bunkeringDateFrom,
  bunkeringDateTo,
  sealNumber,
  arrivalDateAtLabFrom,
  arrivalDateAtLabTo,
  statusId,
  statusDateFrom,
  statusDateTo,
  contractIds
}) => {
  const queryParams = [];
  if (sampleName && sampleName.trim() !== '') {
    queryParams.push(`sampleName=${encodeURIComponent(sampleName.trim())}`);
    queryParams.push('sampleNameOP=Contains');
  }

  // if (bunkeringCountry && bunkeringCountry.id !== '') {
  //   queryParams.push(`bunkeringCountryIds=${encodeURIComponent(bunkeringCountry.id)}`);
  // }

  if (bunkeringCountryIds) {
    queryParams.push(`bunkeringCountryIds=${bunkeringCountryIds}`);
  }

  if (fuelSupplierIds) {
    queryParams.push(`fuelSupplierIds=${fuelSupplierIds}`);
  }

  if (fleetNames) {
    queryParams.push(`fleetNames=${fleetNames}`);
    queryParams.push('fleetNameOP=Contains');
  }

  if (vesselNames) {
    queryParams.push(`vesselNames=${vesselNames}`);
    queryParams.push('vesselNameOP=Contains');
  }

  if (productTypeIds) {
    queryParams.push(`productTypeIds=${productTypeIds}`);
  }

  if (imoNumbers) {
    queryParams.push(`imoNumbers=${imoNumbers}`);
    // queryParams.push('imoNumberOP=Contains');
  }

  if (submissionTypeIds) {
    queryParams.push(`submissionTypeIds=${submissionTypeIds}`);
  }

  if (gradeIds) {
    queryParams.push(`gradeIds=${gradeIds}`);
  }

  if (bunkeringDateFrom && bunkeringDateFrom.trim() !== '') {
    queryParams.push(`bunkeringDateFrom=${encodeURIComponent(bunkeringDateFrom.trim())}`);
  }

  if (bunkeringDateTo && bunkeringDateTo.trim() !== '') {
    queryParams.push(`bunkeringDateTo=${encodeURIComponent(bunkeringDateTo.trim())}`);
  }

  if (sealNumber && sealNumber.trim() !== '') {
    queryParams.push(`sealNumber=${encodeURIComponent(sealNumber.trim())}`);
    queryParams.push('sealNumberOP=Contains');
  }

  if (arrivalDateAtLabFrom && arrivalDateAtLabFrom.trim() !== '') {
    queryParams.push(`arrivalDateAtLabFrom=${encodeURIComponent(arrivalDateAtLabFrom.trim())}`);
  }

  if (statusId) {
    queryParams.push(`statusIds=${statusId}`);
  }

  if (statusDateFrom && statusDateFrom.trim() !== '') {
    queryParams.push(`statusDateFrom=${encodeURIComponent(statusDateFrom.trim())}`);
  }

  if (statusDateTo && statusDateTo.trim() !== '') {
    queryParams.push(`statusDateTo=${encodeURIComponent(statusDateTo.trim())}`);
  }

  if (Array.isArray(contractIds) && contractIds.length > 0) {
    queryParams.push(`contractIds=${contractIds.join(',')}`);
  }

  if (arrivalDateAtLabTo && arrivalDateAtLabTo.trim() !== '') {
    queryParams.push(`arrivalDateAtLabTo=${encodeURIComponent(arrivalDateAtLabTo.trim())}`);
  }

  if (sampleDescription && sampleDescription.trim() !== '') {
    queryParams.push(
      `sampleDescription=${encodeURIComponent(sampleDescription.trim())}`
    );
    queryParams.push('sampleDescriptionOP=Contains');
  }

  if (jobName && jobName.trim() !== '') {
    queryParams.push(`jobName=${encodeURIComponent(jobName.trim())}`);
    queryParams.push('jobNameOP=Contains');
  }

  if (sampleNumber && sampleNumber.trim() !== '') {
    queryParams.push(`sourceSystemSampleID=${encodeURIComponent(sampleNumber.trim())}`);
    queryParams.push('sourceSystemSampleIDOP=Contains');
  }

  if (sampleSource && sampleSource.trim() !== '') {
    queryParams.push(`sampleSource=${encodeURIComponent(sampleSource.trim())}`);
    queryParams.push('sampleSourceOP=Contains');
  }

  if (samplingDateFrom) {
    queryParams.push(
      `samplingDateFrom=${encodeURIComponent(samplingDateFrom)}`
    );
  }

  if (samplingDateTo) {
    queryParams.push(`samplingDateTo=${encodeURIComponent(samplingDateTo)}`);
  }

  if (sampleDateCreatedFrom) {
    queryParams.push(
      `sampleDateCreatedFrom=${encodeURIComponent(sampleDateCreatedFrom)}`
    );
  }

  if (sampleDateCreatedTo) {
    queryParams.push(
      `sampleDateCreatedTo=${encodeURIComponent(sampleDateCreatedTo)}`
    );
  }

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `sampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (sampleType && sampleType.trim() !== '') {
    queryParams.push(
      `sampleTypeNames=${encodeURIComponent(sampleType.trim())}`
    );
  }

  if (sampleCategory && sampleCategory.trim() !== '') {
    queryParams.push(
      `sampleCategory=${encodeURIComponent(sampleCategory.trim())}`
    );
  }

  if (sentBy) {
    queryParams.push(`sentBy=${encodeURIComponent(sentBy.trim())}`);
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(sentFromIds) && sentFromIds.length > 0) {
    queryParams.push(
      `sentFroms=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/sample/all?${queryParams.join('&')}`
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getSampleBySampleId = async ({ sampleId, assignedDivisions }) => {
  const queryParams = [];
  if (Array.isArray(assignedDivisions) && assignedDivisions.length > 0) {
    queryParams.push(`divisionIds=${assignedDivisions.join(',')}`);
  }
  try {
    const response = await axiosInstance.get(`/sample/samples/id/${sampleId}?${queryParams.join('&')}`);

    return response.data;
  } catch (e) {
    throw new Error('Error getSampleBySampleId');
  }
};

const getManyResultsBySampleId = async (sampleId) => {
  try {
    const response = await axiosInstance.get(
      `/sample/results/sampleId/${sampleId}/withSpec`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data; // List of ResultDTO
  } catch (e) {
    throw new Error('Error getManyResultsBySampleId');
  }
};

const searchSampleAlerts = async ({
  locationIDs,
  clientIDs,
  sourceSystemIDs,
  projects,
  page,
  pageSize,
  sortBy,
}) => {
  const queryParams = [];

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/sample/SampleAlerts?${queryParams.join('&')}`
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const createCarRequest = async ({ sampleId }) => {
  try {
    const response = await axiosInstance.post('/sample/CreateCarRequest', {
      SampleID: sampleId,
    });

    return response.data;
  } catch (e) {
    throw new Error('Error createCarRequest');
  }
};

const getTestReportingGroups = async ({ sampleId }) => {
  const queryParams = [];

  if (sampleId) {
    queryParams.push(`sampleIdText=${sampleId}`);
  }
  try {
    const response = await axiosInstance.post(
      `Sample/GetTestReportingGroups?${queryParams.join('&')}`
    );
    // console.log(response.data);
    return response.data;
  } catch (e) {
    throw new Error('Error GetTestReportingGroups');
  }
};

const getRecentSamples = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `sampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `/sample/RecentSamples?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getRecentSamplesVF = async (
  {
    sampleStatusName,
    locationIDs,
    clientIDs,
    sourceSystemIDs,
    divisionIDs,
    projects,
    pageSize,
    page,
    sortBy,
  },
  abortController
) => {
  const queryParams = [];

  if (sampleStatusName && sampleStatusName.trim() !== '') {
    queryParams.push(
      `SampleStatusName=${encodeURIComponent(sampleStatusName.trim())}`
    );
  }

  if (Array.isArray(locationIDs) && locationIDs.length > 0) {
    const ids = locationIDs.join(',');
    queryParams.push(`locationIds=${ids}`);
  }

  if (Array.isArray(clientIDs) && clientIDs.length > 0) {
    const ids = clientIDs.join(',');
    queryParams.push(`clientIds=${ids}`);
  }

  if (Array.isArray(sourceSystemIDs) && sourceSystemIDs.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIDs.join(',')}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(
      `projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`
    );
  }

  if (Array.isArray(divisionIDs) && divisionIDs.length > 0) {
    queryParams.push(`divisionIds=${divisionIDs.join(',')}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.post(
      `Stats/sample/count/all?${queryParams.join('&')}`,
      null,
      {
        signal: abortController?.signal,
      }
    );

    // console.log("Search job result");
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e);
      throw e;
    }
  }

  return [];
};

const getSampleResultHistory = async ({ assetPartId, locationId }, abortController) => {
  const queryParams = [];

  if (assetPartId) {
    queryParams.push(`assetPartId=${encodeURIComponent(assetPartId)}`);
  }

  if (locationId) {
    queryParams.push(`locationId=${locationId}`);
  }

  try {
    const response = await axiosInstance.post(
      `/Sample/GetSampleResultHistory?${queryParams.join('&')}`, {}, {
        signal: abortController?.signal
      }
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Cancel request getSampleResultHistory');
      return {};
    }
    throw e;
  }
};

const getParameters = async ({ analysisType }, abortController) =>
  fetchHandler(axiosInstance,
    '/Sample/Parameters/All', { analysisType }, abortController);
const getFractions = async ({ analysisType }, abortController) =>
  fetchHandler(axiosInstance,
    '/Sample/Fractions/All', { analysisType }, abortController);
const SampleApi = {
  searchSamples,
  getSampleBySampleId,
  getManyResultsBySampleId,
  searchSampleAlerts,
  createCarRequest,
  getRecentSamples,
  getRecentSamplesVF,
  getTestReportingGroups,
  getSampleResultHistory,
  getParameters,
  getFractions
};

export default SampleApi;
